import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

import { PageTitleComponent } from 'common/util/components/pageTitle.component'
import { TranslateDirective } from 'common/locale/directives/translate.directive'
import { TranslatePipe } from 'common/locale'

@Component({
  selector: 'four-oh-four-view',
  templateUrl: './404View.component.html',
  styleUrls: ['./404View.component.scss'],
  imports: [
    PageTitleComponent,
    TranslateDirective,
    TranslatePipe,
  ],
})
export class FourOhFourView {
  constructor (public translate: TranslateService) { }
}
